import { render, staticRenderFns } from "./ModifiedCodeProduct.vue?vue&type=template&id=7faac26b"
import script from "./ModifiedCodeProduct.vue?vue&type=script&lang=js"
export * from "./ModifiedCodeProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports